module.exports = __webpack_public_path__ + "img/bg-08.6ece01cd.jpg";